import 'react-fastclick'

import { CacheProvider } from '@emotion/core'
import * as React from 'react'
import { render } from 'react-dom'
import { ScreenClassProvider, setConfiguration as configureGrid } from 'react-grid-system'

import { createEmotionCache } from 'main/framework/emotion'
import HeadlessRouter from 'main/HeadlessRouter'
import Router from 'main/Router'
import { breakpoints } from 'main/ui'
import './i18n'

import 'normalize.css'
import '../css/core/index.scss'

configureGrid({
  breakpoints: [breakpoints.sm, breakpoints.md, breakpoints.lg, breakpoints.xl],
})
const lego = window.lego || {}
const isHeadless = !!lego.headless
const RouterComponent = isHeadless ? HeadlessRouter : Router

function Main() {
  return (
    <CacheProvider value={createEmotionCache()}>
      <ScreenClassProvider>
        <RouterComponent />
      </ScreenClassProvider>
    </CacheProvider>
  )
}

render(<Main />, document.querySelector('#viewport'))
